<template>
    <div class="h-screen w-screen flex items-center justify-center p-12">
        <div class="max-w-lg text-left">
            <h1 class="text-4xl font-bold text-gray-800">Hier haben wir wohl noch ein paar Lücken.</h1>
            <p class="text-gray-500 mt-5 mb-5">Du hast weitere Informationen für uns? Dann schreib uns einfach an und wir ergänzen es. 😉</p>
            <div class="flex gap-2 items-center mb-10 flex-wrap">
                <p>Mail zum kopieren:</p>
                <button @click="copyToClipboard('pfarramt-rastenberg@ekmd.de')" class="hover:underline font-bold">pfarramt-rastenberg@ekmd.de
                </button>
            </div>
            <div class="flex gap-3 items-center">
                <a href="mailto:pfarramt-rastenberg@ekmd.de" class="py-3 px-5 bg-primary-default hover:bg-primary-hover rounded-md text-white">Mail schreiben</a>
                <router-link to="/" class="py-3 px-5 rounded-md bg-gray-300 hover:bg-gray-400/50">Zurück zur Startseite</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Suggestions',
    methods: {
        copyToClipboard(text) {
            navigator.clipboard.writeText(text);
        }
    }
}
</script>